const NAMESPACE = "sensitiveInput";

const KEYS = {
    showLabel: "showLabel",
    hideLabel: "hideLabel",
    editLabel: "editLabel",
    cancelLabel: "cancelLabel"
};

const MESSAGES = {
    [KEYS.showLabel]: {
        value: "Show",
        comment: "Label for the Add Header button"
    },
    [KEYS.hideLabel]: {
        value: "Hide",
        comment: "Label for the Add Header button"
    },
    [KEYS.editLabel]: {
        value: "Edit",
        comment: "Label for the Add Header button"
    },
    [KEYS.cancelLabel]: {
        value: "Cancel",
        comment: "Label for the Add Header button"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
